import type { CategoryModel } from '@/shared/generated'
import type { Forest } from '@/shared/lib/forest'

import { createForest } from '@/shared/lib/forest'

import { reportCatalogIssue } from './report'

export type CategoryCatalog = Forest<CategoryModel>

export const byName = (
	a: { name: string; id: string },
	b: { name: string; id: string }
) =>
	a.name.localeCompare(b.name, undefined, {
		numeric: true,
		sensitivity: 'base',
	}) || a.id.localeCompare(b.id)

/**
 * The shared category forest. Dedupes by id, sorts siblings by name.
 * `createForest` keys `dataOf`/`parentOf` by `Map`, so duplicate category ids
 * structurally collapse (last wins) and are reported via `forest.duplicates`
 * — callers do not need a `uniqBy` before calling this.
 */
export const createCategoryCatalog = (
	categories: CategoryModel[]
): CategoryCatalog => {
	const catalog = createForest(
		categories.map((category) => ({
			id: category.id,
			parentId: category.parent_id,
			data: category,
		})),
		{ sort: byName }
	)
	if (catalog.orphans.length) {
		reportCatalogIssue('orphan_categories', { ids: catalog.orphans })
	}
	if (catalog.duplicates.length) {
		reportCatalogIssue('duplicate_categories', { ids: catalog.duplicates })
	}

	return catalog
}
